// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"bcfa3871b07f9445876f","276":"d4f3e57713cac14000da"}[chunkId] + ".js";
};